import { render, staticRenderFns } from "./pagamento-mensalidade.vue?vue&type=template&id=033a7012&scoped=true&"
import script from "./pagamento-mensalidade.vue?vue&type=script&lang=js&"
export * from "./pagamento-mensalidade.vue?vue&type=script&lang=js&"
import style0 from "./pagamento-mensalidade.vue?vue&type=style&index=0&id=033a7012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a7012",
  null
  
)

export default component.exports